import {
  get,
  post,
  put,
  del,
} from '@/utils/request';

const url = 'monthly-reports';

export function index({
  page, size, order_by, is_asc, store_id, start_date, end_date,
}) {
  return get({
    url,
    data: {
      store_id,
      start_date,
      end_date,
      order_by,
      is_asc,
      page,
      size,
    },
  });
}

export function getIncomes({ store_id, report_date }) {
  return get({
    url: `${url}/incomes`,
    data: {
      store_id,
      report_date,
    },
  });
}

export function getAttendance({ store_id, report_date }) {
  return get({
    url: `${url}/attendance`,
    data: {
      store_id,
      report_date,
    },
  });
}

export function getCards({ store_id, report_date }) {
  return get({
    url: `${url}/cards`,
    data: {
      store_id,
      report_date,
    },
  });
}

export function getRanks({ store_id, date }) {
  return get({
    url: `${url}/ranks`,
    data: {
      store_id,
      date,
    },
  });
}

export function getTeacherSalaries({ store_id, report_date }) {
  return get({
    url: `${url}/teacher-salaries`,
    data: {
      store_id,
      report_date,
    },
  });
}

export function getInvoices({ store_id, report_date }) {
  return get({
    url: `${url}/invoices`,
    data: {
      store_id,
      report_date,
    },
  });
}

export function getTeacherCourses({ teacher_id, store_id, report_date }) {
  return get({
    url: `${url}/teacher-courses`,
    data: {
      teacher_id,
      store_id,
      report_date,
    },
  });
}

export function getTeacherSalariesByReportId(id, is_include_teacher_info = 0) {
  return get({
    url: `${url}/${id}/teacher-salaries`,
    data: {
      is_include_teacher_info,
    }
  });
}

export function getStaffSalaries({ store_id, report_date }) {
  return get({
    url: `${url}/staff-salaries`,
    data: {
      store_id,
      report_date,
    },
  });
}

export function getStaffSalariesByReportId(id, is_include_staff_info = 0) {
  return get({
    url: `${url}/${id}/staff-salaries`,
    data: {
      is_include_staff_info,
    },
  });
}

export function show(id) {
  return get({
    url: `${url}/${id}`,
  });
}

export function store(data) {
  return post({
    url,
    data,
  });
}

export function update(id, data) {
  return put({
    url: `${url}/${id}`,
    data,
  });
}

export function destroy(id) {
  return del({
    url: `${url}/${id}`,
  });
}
